import React, {useCallback, useRef, useState} from 'react';
import '../../styles/Facilities.css';
import '../../styles/Events.css';
import '../../styles/Inquiry.css';
import '../../styles/Message.css';
import {AiOutlineCheckCircle} from 'react-icons/ai';
import emailjs from '@emailjs/browser';
import {Carousel} from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProtectedFormGate from '../ProtectedFormGate';

function Index() {
    const [modal, setModal] = useState(false);
    const showModal = () => setModal(!modal);

    const form = useRef();

    // ADDED: local-date-safe helper (avoids toISOString's UTC shift causing off-by-one errors)
    const formatDateLocal = (date) => { // ADDED
        const year = date.getFullYear(); // ADDED
        const month = String(date.getMonth() + 1).padStart(2, '0'); // ADDED
        const day = String(date.getDate()).padStart(2, '0'); // ADDED
        return `${year}-${month}-${day}`; // ADDED
    }; // ADDED

    // ADDED: date bounds for validation (today up to 10 years from now)
    const todayStr = formatDateLocal(new Date()); // ADDED
    const maxDateObj = new Date(); // ADDED
    maxDateObj.setFullYear(maxDateObj.getFullYear() + 10); // ADDED
    const maxDateStr = formatDateLocal(maxDateObj); // ADDED

    // Form States
    const [uname, setUname] = useState("");
    const [ucname, setUcname] = useState("");
    const [uemail, setUemail] = useState("");
    const [ucontact, setUcontact] = useState("");
    const [udate, setUdate] = useState("");
    const [unumguest, setUnumGuest] = useState("");
    const [ueventtype, setUeventType] = useState("");

    const fillAccountFields = useCallback(({ user, profile }) => {
        const metadata = user?.user_metadata || {};
        const profileName = profile?.full_name || metadata.full_name || metadata.name || "";
        const profileEmail = profile?.email || user?.email || "";
        const profilePhone = profile?.phone_number || metadata.phone || "";

        setUname((current) => current || profileName);
        setUemail((current) => current || profileEmail);
        setUcontact((current) => current || profilePhone);
    }, []);

    // ADDED: strips digits/symbols from the name as the user types (letters, spaces, hyphens, apostrophes only)
    const handleNameChange = (e) => { // ADDED
        const cleaned = e.target.value.replace(/[^A-Za-z\s'-]/g, ''); // ADDED
        setUname(cleaned); // ADDED
    }; // ADDED

    // ADDED: compares actual Date objects, clamps to today...+10 years
    const handleDateChange = (e) => { // ADDED
        const value = e.target.value; // ADDED
        if (!value) { // ADDED
            setUdate(value); // ADDED
            return; // ADDED
        } // ADDED
        const selected = new Date(value + 'T00:00:00'); // ADDED
        const minAllowed = new Date(todayStr + 'T00:00:00'); // ADDED
        const maxAllowed = new Date(maxDateStr + 'T00:00:00'); // ADDED
        if (selected < minAllowed) { // ADDED
            setUdate(todayStr); // ADDED
            return; // ADDED
        } // ADDED
        if (selected > maxAllowed) { // ADDED
            setUdate(maxDateStr); // ADDED
            return; // ADDED
        } // ADDED
        setUdate(value); // ADDED
    }; // ADDED

    // ADDED: prevents negative, zero, or decimal guest counts
    const handleGuestsChange = (e) => { // ADDED
        const value = e.target.value; // ADDED
        if (value === "") { // ADDED
            setUnumGuest(value); // ADDED
            return; // ADDED
        } // ADDED
        const num = Number(value); // ADDED
        if (Number.isNaN(num) || num < 1) { // ADDED
            setUnumGuest("1"); // ADDED
            return; // ADDED
        } // ADDED
        setUnumGuest(String(Math.floor(num))); // ADDED
    }; // ADDED

    const sendMail = (e) => {
        e.preventDefault();

        // ADDED: hard guard — block sending if date is out of range, even if the live clamp was bypassed
        if (udate) { // ADDED
            const selected = new Date(udate + 'T00:00:00'); // ADDED
            const minAllowed = new Date(todayStr + 'T00:00:00'); // ADDED
            const maxAllowed = new Date(maxDateStr + 'T00:00:00'); // ADDED
            if (selected < minAllowed || selected > maxAllowed) { // ADDED
                setUdate(todayStr); // ADDED
                return; // ADDED
            } // ADDED
        } // ADDED

        // ADDED: hard guard — block sending if guests is invalid
        if (!unumguest || Number(unumguest) < 1) { // ADDED
            setUnumGuest("1"); // ADDED
            return; // ADDED
        } // ADDED

        // ADDED: hard guard — block sending if name contains invalid characters
        if (!/^[A-Za-z\s'-]+$/.test(uname.trim())) { // ADDED
            return; // ADDED
        } // ADDED

        emailjs.sendForm('service_h7e5qsv', 'template_41ql5cx', form.current, '0rx8q5OoEx4JOdxmR')
            .then((result) => {
                e.target.reset();
                setUname(""); setUcname(""); setUemail( ""); setUcontact("");
                setUdate(""); setUnumGuest(""); setUeventType("");
                showModal();
            }, (error) => {
                console.log(error.text);
            });
    };

    const validate = () => {
        // ADDED: name pattern check
        const nameValid = /^[A-Za-z\s'-]+$/.test(uname.trim()); // ADDED

        // ADDED: date-range check via Date objects
        let dateValid = false; // ADDED
        if (udate) { // ADDED
            const selected = new Date(udate + 'T00:00:00'); // ADDED
            const minAllowed = new Date(todayStr + 'T00:00:00'); // ADDED
            const maxAllowed = new Date(maxDateStr + 'T00:00:00'); // ADDED
            dateValid = selected >= minAllowed && selected <= maxAllowed; // ADDED
        } // ADDED

        return uname.length && nameValid && uemail.length && ucontact.length
            && udate.length && dateValid && unumguest.length && Number(unumguest) > 0 && ueventtype.length; // CHANGED: added nameValid, dateValid, and guest > 0 checks
    }

    return (
        <div id="home-events" className="events-page-wrapper">
            <div className="event-container" data-aos="fade-up">
                
                {/* 1. TITLE & DESCRIPTION */}
                <div className="event-header">
                    <h1>EVENTS</h1>
                    <p>Celebrate simple but elegant occasions with our classic and chic function rooms. We can accommodate up to 200 guests.</p>
                </div>

                {/* 2. CENTERED CARDED CAROUSEL */}
                <div className="event-carousel-wrapper">
                    <div className="event-image-card">
                        <Carousel 
                            autoPlay 
                            infiniteLoop 
                            showArrows={false} 
                            showIndicators={false}
                            showThumbs={false} 
                            showStatus={false} 
                            transitionTime={1000}
                        >
                            <div className='event-img-frame'><img src="/vscimages/events/Events.jpg" alt="Event" /></div>
                            <div className='event-img-frame'><img src="/vscimages/events/events2.jpg" alt="Event" /></div>
                            <div className='event-img-frame'><img src="/vscimages/events/events3.jpg" alt="Event" /></div>
                            <div className='event-img-frame'><img src="/vscimages/events/events4.jpg" alt="Event" /></div>
                        </Carousel>
                    </div>
                </div>

                {/* 3. CARDED FORM BELOW */}
                <div className="event-form-card">
                    <ProtectedFormGate
                        title="Sign in to submit an event inquiry"
                        description="Log in or create an account so our events team can keep your inquiry details connected to your profile."
                        contextLabel="Event inquiry"
                        formRef={form}
                        onAuthenticated={fillAccountFields}
                    >
                        {({ guardSubmit }) => (
                            <>
                                <h2>Inquiry Form</h2>
                                <form ref={form} onSubmit={(e) => guardSubmit(e, sendMail)}>
                                    <div className="form-grid-layout">
                                        <div className="form-group">
                                            <label>Full Name</label>
                                            <input
                                                type="text"
                                                name="user_name"
                                                value={uname}
                                                onChange={handleNameChange}
                                                placeholder="Enter your name"
                                                pattern="[A-Za-z\s'-]+"
                                                title="Name must not contain numbers or symbols"
                                            />
                                            {/* CHANGED: onChange now uses handleNameChange; added pattern + title */}
                                        </div>
                                        <div className="form-group">
                                            <label>Company Name<span style={{ fontSize: '10px', color: '#7f8c8d', fontWeight: '400' }}>(Optional)</span></label>
                                            <input type="text" name="user_company" value={ucname} onChange={(e) => setUcname(e.target.value)} placeholder="Enter company name" />
                                        </div>
                                        <div className="form-group">
                                            <label>Email Address</label>
                                            <input type="email" name="user_email" value={uemail} onChange={(e) => setUemail(e.target.value)} placeholder="email@example.com" />
                                        </div>
                                        <div className="form-group">
                                            <label>Contact Number</label>
                                            <input type="number" name="user_contact" value={ucontact} onChange={(e) => setUcontact(e.target.value)} placeholder="09XXXXXXXXX" />
                                        </div>
                                        <div className="form-group">
                                            <label>Event Date</label>
                                            <input
                                                type="date"
                                                name="event_date"
                                                value={udate}
                                                onChange={handleDateChange}
                                                min={todayStr}
                                                max={maxDateStr}
                                            />
                                            {/* CHANGED: onChange now uses handleDateChange; added min/max */}
                                        </div>
                                        <div className="form-group">
                                            <label>No. of Guests</label>
                                            <input
                                                type="number"
                                                name="num_guest"
                                                value={unumguest}
                                                onChange={handleGuestsChange}
                                                min="1"
                                                placeholder="0"
                                            />
                                            {/* CHANGED: onChange now uses handleGuestsChange; added min */}
                                        </div>
                                        <div className="form-group full-span">
                                            <label>Event Type</label>
                                            <input type="text" name="event_type" value={ueventtype} onChange={(e) => setUeventType(e.target.value)} placeholder="e.g. Wedding, Birthday, Corporate" />
                                        </div>
                                    </div>
                                    <button className='event-submit-btn' type="submit" disabled={!validate()}>Submit Inquiry</button>
                                </form>
                            </>
                        )}
                    </ProtectedFormGate>
                </div>
            </div>

            {/* MODAL */}
            <div className={modal ? 'modal-wrap active': 'modal-wrap' }>
                <div className="modal-box">
                    <AiOutlineCheckCircle className='checkIcon' />
                    <h1>Thank You!</h1>
                    <p>Your details have been successfully submitted.</p>
                    <div className="exit-btn"><button onClick={showModal}>OK</button></div>
                </div>
            </div>
        </div>
    );
}

export default Index;


// import React, {useRef, useState} from 'react';
// import '../../styles/Facilities.css';
// import '../../styles/Events.css';
// import '../../styles/Inquiry.css';
// import '../../styles/Message.css';
// import {AiOutlineCheckCircle} from 'react-icons/ai';
// import emailjs from '@emailjs/browser';

// import '../../styles/CarouselExtend.css';
// import {Carousel} from 'react-responsive-carousel';
// import "react-responsive-carousel/lib/styles/carousel.min.css";

// function Index() {

//     //Modal message pop
//     const [modal, setModal] = useState(false);

//     const showModal = () => {
//         setModal(!modal);
//     }

//     //email form function
//     const form = useRef();

//     const sendMail = (e) => {
//         e.preventDefault();

//         // emailjs.sendForm('service_pnnw3xk', 'template_utyr6nq', form.current, '75jsZlR0TkKSSLLKn')
//         emailjs.sendForm('service_h7e5qsv', 'template_41ql5cx', form.current, '75jsZlR0TkKSSLLKn')
//             .then((result) => {
//                 e.target.reset();
//                 //reset the value after submit
//                 setUname("");
//                 setUcname("");
//                 setUemail("");
//                 setUcontact("");
//                 setUdate("");
//                 setUnumGuest("");
//                 setUeventType("");
//                 // alert("success");
//             }, (error) => {
//                 // console.log(error.text);
//             });
//     };

//     //form value
//     const [uname, setUname] = useState("");
//     const [ucname, setUcname] = useState("");
//     const [uemail, setUemail] = useState("");
//     const [ucontact, setUcontact] = useState("");
//     const [udate, setUdate] = useState("");
//     const [unumguest, setUnumGuest] = useState("");
//     const [ueventtype, setUeventType] = useState("");

//     //check if form is filled
//     const validate = () => {
//         return uname.length && ucname.length && uemail.length && ucontact.length && udate.length && unumguest.length && ueventtype.length;
//     }

//   return (
//     <>
//         <div id="home-events" className="extend-carousel" data-aos="fade">
//             <div>
//                 <Carousel className='carousel'
//                     width dynamicHeight={true}
//                     autoPlay={true}
//                     stopOnHover={false}
//                     showArrows={false}
//                     showThumbs={false}
//                     infiniteLoop={true}
//                     fade={true}
//                     showStatus={false}
//                     transition={1500}
//                     swipeable={false}
//                     animationHandler='fade'
//                 >

//                     <div className='cell'>
//                         <img src="/vscimages/events/events4.jpg" alt="" />
//                     </div>

//                     <div className='cell'>
//                         <img src="/vscimages/events/events.jpg" alt="" />
//                     </div>

//                     <div className='cell'>
//                         <img src="/vscimages/events/events3.jpg" alt="" />
//                     </div>

//                     <div className='cell'>
//                         <img src="/vscimages/events/events2.jpg" alt="" />
//                     </div>
                    
//                 </Carousel>
//             </div>
//         </div>

//         {/**MODAL POP-UP */}
//       <div className={modal ? 'modal-wrap active': 'modal-wrap' }>
//         <div className="modal-box">
//           <AiOutlineCheckCircle className='checkIcon' />
//           <h1>Thank You!</h1>
//           <p>Your details has been successfully <br/> submitted. Thanks!</p>

//           <div className="exit-btn">
//               <button onClick={showModal}>OK</button>
//           </div>
//         </div>
//       </div>

//       <div className="event-wrap" data-aos="fade-up" >
//           <div className="event-title">
//             <h1>EVENTS</h1>
//             <p>
//               Celebrate simple but elegant occasions with our classic and chic
//               function rooms. We can do Socials, Corporate functions, or Intimate
//               gatherings. We can accommodate up to 200 guests.
//             </p>
//           </div>

//           <div className="event-inquiry">
//             <div className="inquiry-form">
//                 <form ref={form} onSubmit={sendMail} >
//                   <div className="form-grid">
//                     <div>
//                       <label htmlFor="user_name">Name</label>
//                       <input type="text" name="user_name" id="user_name" value={uname} onChange={(e) => setUname(e.target.value)} />
//                     </div>
//                     <div>
//                       <label htmlFor="user_company">Company Name</label>
//                       <input type="text" name="user_company" id="user_company" value={ucname} onChange={(e) => setUcname(e.target.value)} />
//                     </div>
//                   </div>

//                   <div className="form-grid">
//                     <div>
//                       <label htmlFor="user_email">Email Address</label>
//                       <input type="email" name="user_email" id="user_email" value={uemail} onChange={(e) => setUemail(e.target.value)} />
//                     </div>
//                     <div>
//                       <label htmlFor="user_contact">Contact Number</label>
//                       <input type="number" name="user_contact" id="user_contact" value={ucontact} onChange={(e) => setUcontact(e.target.value)} />
//                     </div>
//                   </div>

//                   <div className="form-gridB">

//                     <div>
//                       <label htmlFor="event_date">Date of Event</label>
//                       <input type="date" name="event_date" value={udate} onChange={(e) => setUdate(e.target.value)} />
//                     </div>
//                     <div>
//                       <label htmlFor="num_guest">Number of Guest</label>
//                       <input type="number" name="num_guest" value={unumguest} onChange={(e) => setUnumGuest(e.target.value)} />
//                     </div>
//                     <div>
//                       <label htmlFor="event_type">Type of Event</label>
//                       <input type="text" name="event_type" value={ueventtype} onChange={(e) => setUeventType(e.target.value)} />
//                     </div>
//                   </div>

//                   <div className="submit-btn-wrap">
//                     <button className='submit-btn-event' type="submit" onClick={showModal} disabled={!validate()}>Submit</button>
//                   </div>
//                 </form>
//             </div>
//           </div>
//       </div>
//     </>
//   )
// }

// export default Index
